<template>
 <div class="astrology_forget_password astrology-auth-container ">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto" id="astrologyFormDiv">
          <ForgetPassword guard="AV"
             logoSrc="astrology/av-logo-auth.png"
            clientLink="astrology_ventures"
            welcomeHeader="Reset Passsword"
            welcomeSubheader="Please enter your registered email to send you an link to reset your password"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgetPassword from "@/components/auth/ForgetPassword.vue";

export default {
  name: "AstrologyForgetPassword",
  components: { ForgetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit forget password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/astrology-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/astrology_ventures/auth/ForgetPasswordView.vue